import { createApp } from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';

import router from './router';
import App from './App.vue';
import ClickOutside from './directives/clickOutside';
import AuthServiceProxy from "@/utils/auth.service";
import Config from "@/utils/config.service";

declare module "@vue/runtime-core" {
    export interface ComponentCustomProperties {
        $http: typeof axios;
    }
}

const configInstance = Config.getInstance();
configInstance.setConfigUrl("config.json");

axios.defaults.headers.common["X-Access-Token"] = "r8incg1rmxw4jc3cdyhm8h28jgfusqmp";

/**
 * Vypíše chybu přímo do #app. Bez toho se aplikace jen nenamountuje a uživatel vidí
 * prázdnou bílou stránku bez jakékoli informace o tom, co se stalo.
 * Staví se ručně přes DOM, protože v tomhle bodě ještě neběží Vue ani globální styly.
 */
function showStartupError(error: unknown): void {
    console.error("Aplikaci se nepodařilo spustit", error);

    const host = document.getElementById("app");
    if (host === null) {
        return;
    }

    host.innerHTML = `
        <div style="font-family: Roboto, Arial, sans-serif; color: #1a1a1a; max-width: 40rem; margin: 4rem auto; padding: 0 1.5rem;">
            <h1 style="font-size: 1.5rem; margin: 0 0 1rem 0;">Aplikaci se nepodařilo spustit</h1>
            <p style="line-height: 1.5; margin: 0 0 1rem 0;">
                Nepodařilo se dokončit přihlášení. Zkuste stránku načíst znovu. Pokud to nepomůže,
                smažte v prohlížeči data tohoto webu a přihlaste se znovu. Když potíže potrvají,
                pošlete prosím správci text níže.
            </p>
            <p id="startup-error-detail" style="background: #f4f4f4; border-left: 4px solid #b32121; padding: .75rem 1rem; margin: 0 0 1.5rem 0; font-size: .875rem; word-break: break-word;"></p>
            <button id="startup-error-reload" type="button" style="background: #b32121; color: #fff; border: none; cursor: pointer; font-size: 1rem; padding: .75rem 1.5rem;">
                Načíst znovu
            </button>
        </div>
    `;

    // textContent, ať se text chyby nikdy neinterpretuje jako HTML
    const detail = document.getElementById("startup-error-detail");
    if (detail !== null) {
        detail.textContent = error instanceof Error ? error.message : String(error);
    }

    const reload = document.getElementById("startup-error-reload");
    if (reload !== null) {
        reload.addEventListener("click", () => location.reload());
    }
}

let app;
AuthServiceProxy.createInstance(configInstance)
    .then(() => {
        app = createApp(App)
            .directive('detect-click', ClickOutside)
            .use(router)
            .use(VueAxios, axios)
            .mount('#app');
    })
    .catch(showStartupError);
